import {
  FacebookImportRequestConfirmationQuery,
  FacebookImportRequestConfirmationQueryVariables
} from './__generated__/FacebookImportRequestConfirmationQuery';
import { useQuery } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { FACEBOOK_IMPORT_REQUEST_CONFIRMATION_QUERY } from './facebookImportRequestConfirmation.query';

export const useFacebookImportRequestConfirmationQuery = (
  variables: FacebookImportRequestConfirmationQueryVariables
) => {
  return useQuery<FacebookImportRequestConfirmationQuery>(FACEBOOK_IMPORT_REQUEST_CONFIRMATION_QUERY, {
    variables,
    client: kmsClient,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  });
};
